import type {InlineNotificationContentModel} from '../badgeDetails';

export const INLINE_NOTIFICATION_VARIANTS = {
    DEFAULT: 'default',
    GRADIENT: 'gradient',
} as const;

export type InlineNotificationVariant =
    (typeof INLINE_NOTIFICATION_VARIANTS)[keyof typeof INLINE_NOTIFICATION_VARIANTS];

/**
 * Re-exported alias matching the main app's naming.
 * Loyalty uses a simpler content shape (title + description only).
 */
export type InlineNotificationModel = InlineNotificationContentModel;
